// extracted by mini-css-extract-plugin
export default {"radiorer":"XbRBy3","size-20":"OkQ10h","size-22":"YYyn5B","label":"OFYbtu"};